import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] lg:h-screen w-full flex items-center justify-center overflow-hidden bg-white pt-20">
      <div className="absolute inset-0 grid-bg opacity-20"></div>
      
      <div className="relative z-10 w-full max-w-[1600px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          >
            <h1 className="text-[14vw] lg:text-[9vw] font-black leading-[0.85] tracking-tighter uppercase mb-8">
              See In<br/>
              <span className="prism-text select-none">Spectra.</span>
            </h1>
          </motion.div>
          
          <motion.div 
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="flex flex-col md:flex-row md:items-end gap-10"
          >
            <p className="text-xl md:text-2xl font-medium max-w-sm text-gray-900 leading-[1.1]">
              Precision optics for the bold. A new architectural standard for the eyes.
            </p>
            <div className="flex flex-col gap-4">
              <a href="#drops" className="group relative inline-flex items-center justify-center px-12 py-5 font-black text-xs tracking-[0.3em] text-white bg-black overflow-hidden uppercase">
                <span className="absolute inset-0 w-full h-full prism-gradient translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-500"></span>
                <span className="relative z-10">Enter Studio</span>
              </a>
              <p className="text-[10px] font-black tracking-[0.4em] uppercase text-gray-400">Project v2.4.0 / Prism Labs</p>
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-5 relative hidden lg:block">
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.3, duration: 1.2 }}
            className="relative z-10 border-[12px] border-black aspect-[4/5] overflow-hidden"
          >
            <motion.img 
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 1.5 }}
              src="https://images.unsplash.com/photo-1572635196237-14b3f281503f?auto=format&fit=crop&q=80&w=800" 
              className="w-full h-full object-cover grayscale"
              alt="PrismPeak Studio Experience"
            />
          </motion.div>
          <div className="absolute -bottom-8 -left-8 w-40 h-40 prism-gradient -z-10 opacity-50 blur-2xl"></div>
        </div>
      </div>

      <motion.div 
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="absolute bottom-12 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 opacity-30"
      >
        <div className="w-[2px] h-16 bg-black"></div>
      </motion.div>
    </section>
  );
};

export default Hero;